var exports = {
  "$": "Button__-twu7M",
};

module.exports = exports;
